import React, { useState } from 'react';
import { useTranslate } from '@hooks';
import { Collapse } from 'reactstrap';
import { ChevronDown as DownIcon, ChevronUp as UpIcon } from 'react-feather';
import { Button, Text } from '@dotone/react-ui-core';

const OfferApprovalMessageDataCell = ({ offer }) => {
  const { t } = useTranslate('offer', 'model');
  const { approvalMessage } = offer;
  const [isDisclaimerOpen, setDisclaimerOpen] = useState(false);

  return (
    <td colSpan="4">
      {approvalMessage && (
        <>
          <Button color="link" className="p-0" onClick={() => setDisclaimerOpen(!isDisclaimerOpen)}>
            {isDisclaimerOpen ? (
              <UpIcon size={16} className="mr-1" />
            ) : (
              <DownIcon size={16} className="mr-1" />
            )}
            {isDisclaimerOpen ? t('hideDisclaimer') : t('seeDisclaimer')}
          </Button>
          <Collapse isOpen={isDisclaimerOpen}>
            <Text html>{approvalMessage}</Text>
          </Collapse>
        </>
      )}
    </td>
  );
};

export default React.memo(OfferApprovalMessageDataCell);
